import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'filled-question-icon',
  templateUrl: './filled-question-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilledQuestionIconComponent {}
